import { AutoDeleteField, MediaUploadLabel } from '../../MediaFields';

export default function AudioNode({ id, data }) {
    const media = data?.media || {};
    const audioKey = media.audio ? 'audio' : 'voice';
    const audioValue = media.audio || media.voice;

    if (data?.uploadingMedia) return (
        <div className="mt-2">
            <div className="border-2 border-dashed rounded-lg p-3 border-white/[0.06] flex flex-col items-center gap-1">
                <i className="fas fa-spinner fa-spin text-white/40 text-lg" />
                <p className="text-[10px] text-white/50">Enviando...</p>
                <p className="text-[9px] text-white/30">aguarde</p>
            </div>
        </div>
    );

    return (
        <div className="mt-2 space-y-2">
            {audioValue ? (
                <>
                    <label className="relative border-2 border-dashed rounded-lg p-3 transition-colors cursor-pointer border-white/[0.06] hover:border-white/[0.08] block">
                        <input accept="audio/ogg,audio/mpeg,audio/wav,audio/mp4,audio/m4a,.ogg,.mp3,.wav,.m4a" className="hidden" type="file"
                            onChange={(e) => { const f = e.target.files?.[0]; if (f) data?.onUploadMedia?.(id, 'audio', f); e.target.value = ''; }} />
                        {/* <button
                            type="button"
                            className="absolute top-1 right-1 text-red-400 hover:text-red-300 z-10 text-[10px]"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); data?.onDeleteMedia?.(id, audioKey); }}
                        >
                            <i className="fas fa-trash" />
                        </button> */}
                        <div className="flex items-center justify-center py-3">
                            <i className="fas fa-music text-purple-400 text-2xl opacity-80" />
                        </div>
                        <p className="text-[10px] text-white/50 truncate max-w-full mt-1">
                            {media.fileName || audioValue}
                        </p>
                        <p className="text-[9px] text-white/30">Clique para trocar</p>
                    </label>
                    <input type="text" className="input3 w-full" placeholder="Legenda (opcional)"
                        value={media.caption || ''}
                        onChange={(e) => data?.onChangeMedia?.(id, { caption: e.target.value })} />
                    <AutoDeleteField
                        value={media.auto_delete_seconds}
                        onToggle={(checked) => data?.onChangeMedia?.(id, { auto_delete_seconds: checked ? 5 : null })}
                        onChangeSeconds={(v) => data?.onChangeMedia?.(id, { auto_delete_seconds: v })} />
                </>
            ) : (
                <MediaUploadLabel accept="audio/ogg,audio/mpeg,audio/wav,audio/mp4,audio/m4a,.ogg,.mp3,.wav,.m4a"
                    onUpload={(f) => data?.onUploadMedia?.(id, 'audio', f)} />
            )}
        </div>
    );
}
